// extracted by mini-css-extract-plugin
export var boldCellText = "_8ed9f833abc644c712845acbb6ccb409-css";